module.exports = require("superagent");


//////////////////
// WEBPACK FOOTER
// external "superagent"
// module id = 18
// module chunks = 0